<div class="media-recorder" [@appearWrapper]>
  <button
    *ngIf="!isVoiceRecording || !isRecordingAvailable; else activeRecordingButtons"
    tuiIconButton
    class="media-recorder__button"
    type="button"
    appearance="icon"
    iconStart="@tui.mic"
    size="s"
    [tuiHint]="'components.mediaRecorder.buttons.record' | translate"
    [@appear]
    (click)="startRecording()"
  ></button>
  <ng-template #activeRecordingButtons>
    <button
      tuiButton
      class="media-recorder__button media-recorder__button_pulse"
      type="button"
      appearance="custom"
      [style.border-radius.%]="100"
      size="s"
      [tuiHint]="'common.buttons.send' | translate"
      [@appear]
      (click)="emitRecord()"
    >
      <app-icon [src]="'send'"></app-icon>
    </button>
    <button
      tuiIconButton
      class="media-recorder__button"
      type="button"
      appearance="custom"
      iconStart="@tui.x"
      size="s"
      [tuiHint]="'common.buttons.cancel' | translate"
      [@appear]
      (click)="stopRecording()"
    ></button>
  </ng-template>
</div>
